import store from '@/store'
import { Message } from 'element-ui'
import { MessageBox } from 'element-ui';
import { getToken, setToken } from '@/utils/auth';
import { title } from '@/settings';
import mpsynp from './25_爱给网_aigei_com.mp3'
import Vue from 'vue';
import router from '@/router' // 引入路由实例

var url = 'wss://carercom.com/wsServer/'
var ws;
var tt;
var lockReconnect = false;//避免重复连接
var client = localStorage.getItem('clientId')//缓存中取出客户端id

var websocket = {
  Init: function(client) {
    if ('WebSocket' in window) {
      ws = new WebSocket(url + client);
    } else if ("MozWebSocket" in window) {
      ws = new MozWebSocket(url + client);
    } else {
      console.log("您的浏览器不支持 WebSocket!");
      return;
    }

    ws.onmessage = function(e) {
      const msg = JSON.parse(e.data)
      messageHandle(msg)
      heartCheck.start()
    }

    ws.onclose = function() {
      reconnect(client);
    }

    ws.onopen = function() {
      heartCheck.start();
    }

    ws.onerror = function(e) {
      console.log("数据传输发生错误");
      Message({
      		message: '数据传输发生错误',
      		type: 'error',
      });
      reconnect(client)
    }
  },
  Send:function(sender,reception,body,flag){
    let data = {
      sender:sender,
      reception:reception,
      body:body,
      flag:flag
    }
    let msg= JSON.stringify(data)
    ws.send(msg)
  },
  Close:function() {
    lockReconnect = true;
    ws.close();
  },
  getWebSocket(){
    return ws;
  },
  getStatus() {
    if (ws.readyState == 0) {
      return "未连接";
    } else if (ws.readyState == 1) {
      return "已连接";
    } else if (ws.readyState == 2) {
      return "连接正在关闭";
    } else if (ws.readyState == 3) {
      return "连接已关闭";
    }
  }
}

export default websocket;

//根据消息标识做不同的处理
function messageHandle(message) {
  const audio = new Audio();
  audio.src = mpsynp;
  const messageType = message
  switch (messageType.msgType) {
    case 'command':
      console.log('指令消息类型')
      break;
    case 'state':
      console.log('状态')
      break;
    case 'inform':
      console.log('通知')
      break;
    case 'data':
      if (messageType.data.dataType === 'mattress') {
        Vue.prototype.$bus.$emit('mattress-data', messageType.data);
      }
      if (messageType.data.dataType === 'vitalSignDetector') {
        Vue.prototype.$bus.$emit('vitalSignDetector-data', messageType.data);
      }
      break;
    case 'alarm':
      if (['/displayShow'].includes(router.app.$route.path)) {
        Vue.prototype.$bus.$emit('mapAlarm-data', messageType.data);
      }else{
        audio.loop = true;
        /* 音频可以播放；如果权限允许则播放 */
      audio.play();
      // 设置自定义样式
      const customStyle = '.my-message-box {width: 500px;height: 400px;margin-bottom: 280px;align-items: center;}.my-confirmBut {margin-right: 30px;margin-top: 56px;padding: 10px 25px;font-size: 14px;}.my-cancelBut{padding: 10px 25px;font-size: 14px;}.custom-svg-icon{background: url(background: url(../../assets/logo_images/login_left.jpg)}'
      // 创建style标签并添加到head
      const style = document.createElement('style')
      style.type = 'text/css'
      style.innerHTML = customStyle
      document.head.appendChild(style)
      const html = '<div style="width:400px;height: 180px;font-size:15px;margin-top:10px;margin-left: auto;margin-right: auto;">' +
    '<ul style="list-style-type: none;margin-left: -20px;line-height:2;text-align: left;font-weight: bold;">' +
    '<li>报警老人:<span style="margin-left: 10px;color:red">' + messageType.data.elderlyName + '</span></li>' +
    '<li>报警类型:<span style="margin-left: 10px;color:red">' + messageType.data.alarmName + '</span></li>' +
    '<li>报警设备:<span style="margin-left: 10px;">' + messageType.data.productName + '</span></li>' +
    '<li>设备ID:<span style="margin-left: 14px;">' + messageType.data.serialNumber + '</span></li>' +
    '<li>报警时间:<span style="margin-left: 10px;">' + messageType.data.alarmTime + '</span></li>' +
    '<li>所属机构:<span style="margin-left: 10px;">' + messageType.data.international + '</span></li>' +
    '<li>报警地址:<span style="margin-left: 10px;">' + messageType.data.alarmDress + '</span></li>' +
    '<li>所属服务中心:<span style="margin-left: 10px;">' + messageType.data.serviceCenter + '</span></li>' +
    '</ul>' +
    '</div>'
    MessageBox.confirm(
      html,
      messageType.data.elderlyName + '-' + messageType.data.alarmName,
      {
        confirmButtonText: '去处理',
        cancelButtonText: '知道了',
        dangerouslyUseHTMLString: true,
        customClass: 'my-message-box',
        cancelButtonClass: 'my-cancelBut',
        confirmButtonClass: 'my-confirmBut',
        center: true,
        iconClass: 'custom-svg-icon', // 设置外部图标的URL
      }
    ).then(() => {
      audio.pause();
      // 跳转到另一个页面
      window.location.href = '/#/alarm/alarmList';
    }).catch(() => {
      audio.pause();
    });
      }
      break;
    default:
      console.log('未知消息类型')
  }
}

function reconnect(sname) {
  if (lockReconnect) {
    return;
  };
  lockReconnect = true;
  //没连接上会一直重连，设置延迟避免请求过多
  tt && clearTimeout(tt);
  tt = setTimeout(function () {
    websocket.Init(sname)
    lockReconnect = false
  }, 4000)
}

//心跳检测
var heartCheck = {
  timeout: 30000,
  timeoutObj: null,
  serverTimeoutObj: null,
  start: function() {
    var self = this
    this.timeoutObj && clearTimeout(this.timeoutObj)
    this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj)
    this.timeoutObj = setTimeout(function() {
      //创建一个new data对象来获取当前日期
      const currentDate = new Date()
      //获取时间，以字符串格式显示
      const timeString = currentDate.toLocaleTimeString()
      //这里发送一个心跳，后端收到后，返回一个心跳消息，
      //onmessage拿到返回的心跳就说明连接正常
      const data = { msgType: 'heartBeat', data: timeString }
      ws.send(JSON.stringify(data))
      self.serverTimeoutObj = setTimeout(function() {
        if (ws.readyState!=1) {
          ws.close()
        }
        // createWebSocket();
      }, self.timeout)

    }, this.timeout)
  }
}

